import { IApplicationState } from 'shared/types/redux';

export const selectIsApplicationStatusModalOpen = (state: IApplicationState) =>
  state.landing.applicationStatusModal.isOpen;

export const selectApplicationStatusApplication = (state: IApplicationState) =>
  state.landing.applicationStatusModal.application;

export const selectApplicationStatusPlace = (state: IApplicationState) => state.landing.applicationStatusModal.place;
